<template>
  <button
    class="fixed bottom-14 right-8 z-0 flex size-10 items-center justify-center rounded-full border-2 border-black text-3xl opacity-25 transition-opacity duration-300 sm:bottom-20 sm:right-16 sm:size-16 sm:text-3xl"
    :class="{
      'sm:hover:opacity-100': !top,
      'max-sm:opacity-100': !top && !toTop,
    }"
    aria-label="Back to top"
    @click="scrollToTop"
  >
    <Icon name="material-symbols-light:arrow-warm-up" />
  </button>
</template>

<script setup lang="ts">
const { gsap } = useGsap()
const { arrivedState, directions } = useScroll(window)
const { top } = toRefs(arrivedState)
const { top: toTop } = toRefs(directions)

const scrollToTop = () => {
  gsap.to(window, {
    scrollTo: {
      y: 0,
      autoKill: true,
    },
    duration: 1,
    ease: "power2",
  })
}
</script>
